import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
import { obx, computed, makeObservable } from '@alilc/lowcode-editor-core';
import { ScrollTarget } from '../designer';
import { AutoFit } from '../simulator';
var Viewport = (_dec = obx.ref, _dec2 = obx.ref, _dec3 = obx.ref, _dec4 = obx.ref, _dec5 = obx.ref, _dec6 = obx.ref, (_class = /*#__PURE__*/function () {
  function Viewport() {
    _initializerDefineProperty(this, "rect", _descriptor, this);
    this._bounds = void 0;
    this.viewportElement = void 0;
    _initializerDefineProperty(this, "_scale", _descriptor2, this);
    _initializerDefineProperty(this, "_contentWidth", _descriptor3, this);
    _initializerDefineProperty(this, "_contentHeight", _descriptor4, this);
    _initializerDefineProperty(this, "_scrollX", _descriptor5, this);
    _initializerDefineProperty(this, "_scrollY", _descriptor6, this);
    this._scrollTarget = void 0;
    _initializerDefineProperty(this, "_scrolling", _descriptor7, this);
    makeObservable(this);
  }
  var _proto = Viewport.prototype;
  _proto.mount = function mount(viewportElement) {
    if (!viewportElement || this.viewportElement === viewportElement) {
      return;
    }
    this.viewportElement = viewportElement;
    this.touch();
  };
  _proto.touch = function touch() {
    if (this.viewportElement) {
      this.rect = this.bounds;
    }
  };
  _proto.setScrollTarget = function setScrollTarget(target) {
    var _this = this;
    var scrollTarget = new ScrollTarget(target);
    this._scrollX = scrollTarget.left;
    this._scrollY = scrollTarget.top;
    var scrollTimer;
    target.addEventListener('scroll', function () {
      _this._scrollX = scrollTarget.left;
      _this._scrollY = scrollTarget.top;
      _this._scrolling = true;
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(function () {
        _this._scrolling = false;
      }, 80);
    });
    target.addEventListener('resize', function () {
      return _this.touch();
    });
    this._scrollTarget = scrollTarget;
  };
  _proto.toGlobalPoint = function toGlobalPoint(point) {
    if (!this.viewportElement) {
      return point;
    }
    var rect = this.bounds;
    return {
      clientX: point.clientX * this.scale + rect.left,
      clientY: point.clientY * this.scale + rect.top
    };
  };
  _proto.toLocalPoint = function toLocalPoint(point) {
    if (!this.viewportElement) {
      return point;
    }
    var rect = this.bounds;
    return {
      clientX: (point.clientX - rect.left) / this.scale,
      clientY: (point.clientY - rect.top) / this.scale
    };
  };
  _createClass(Viewport, [{
    key: "bounds",
    get: function get() {
      var _this2 = this;
      if (this._bounds) {
        return this._bounds;
      }
      this._bounds = this.viewportElement.getBoundingClientRect();
      requestAnimationFrame(function () {
        _this2._bounds = undefined;
      });
      return this._bounds;
    }
  }, {
    key: "contentBounds",
    get: function get() {
      var bounds = this.bounds,
        scale = this.scale;
      return new DOMRect(0, 0, bounds.width / scale, bounds.height / scale);
    }
  }, {
    key: "height",
    get: function get() {
      if (!this.rect) {
        return 600;
      }
      return this.rect.height;
    },
    set: function set(newHeight) {
      this._contentHeight = newHeight / this.scale;
      if (this.viewportElement) {
        this.viewportElement.style.height = newHeight + "px";
        this.touch();
      }
    }
  }, {
    key: "width",
    get: function get() {
      if (!this.rect) {
        return 1000;
      }
      return this.rect.width;
    },
    set: function set(newWidth) {
      this._contentWidth = newWidth / this.scale;
      if (this.viewportElement) {
        this.viewportElement.style.width = newWidth + "px";
        this.touch();
      }
    }
  }, {
    key: "scale",
    get:
    /**
     * 缩放比例
     */
    function get() {
      return this._scale;
    },
    set: function set(newScale) {
      if (isNaN(newScale) || newScale <= 0) {
        throw new Error("invalid new scale \"" + newScale + "\"");
      }
      this._scale = newScale;
      this._contentWidth = this.width / this.scale;
      this._contentHeight = this.height / this.scale;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this._contentHeight;
    },
    set: function set(newContentHeight) {
      this._contentHeight = newContentHeight;
    }
  }, {
    key: "contentWidth",
    get: function get() {
      return this._contentWidth;
    },
    set: function set(val) {
      this._contentWidth = val;
    }
  }, {
    key: "scrollX",
    get: function get() {
      return this._scrollX;
    }
  }, {
    key: "scrollY",
    get: function get() {
      return this._scrollY;
    }
  }, {
    key: "scrollTarget",
    get:
    /**
     * 滚动对象
     */
    function get() {
      return this._scrollTarget;
    }
  }, {
    key: "scrolling",
    get: function get() {
      return this._scrolling;
    }
  }]);
  return Viewport;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "rect", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "height", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "height"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "width", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "width"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_scale", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _applyDecoratedDescriptor(_class.prototype, "scale", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "scale"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_contentWidth", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return AutoFit;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_contentHeight", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return AutoFit;
  }
}), _applyDecoratedDescriptor(_class.prototype, "contentHeight", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentWidth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentWidth"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_scrollX", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_scrollY", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_scrolling", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class));
export { Viewport as default };